import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ViewChildren,
  QueryList
} from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { MultiSelect } from 'primeng/multiselect';
import { Table } from 'primeng/table';
import { Subject } from 'rxjs';
import {
  emailAttachments,
  PartnerEmailTemplate,
  PartnerBulkEmailTemplateDetails,
  EmailBroadCastInput
} from '../../../models/email-broadcast.model';
import { EngagementPreviewInput } from '../../../models/engagement-preview-input.model';
import { TaskOwner } from '../../../models/task-owner.model';
import { AppConstants } from '../../common/app-constants';
import { CommonSharedModule } from '../../common/shared.module';
import { EditComponent } from '../../home/edit/edit.component';
import { LocalStorageService } from '../../services/local-storage-service';
import { OsmosisService } from '../../services/osmosis.service';

@Component({
  selector: 'app-batch-manage-template',
  templateUrl: './batch-manage-template.component.html',
  styleUrls: ['./batch-manage-template.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class BatchManageTemplateComponent implements OnInit {
  @Input() refreshData!: Subject<boolean>;
  htmlTemplate!: string;
  subjectTemplate!: string;
  emailAttachments!: emailAttachments[];
  recipientCategory: SelectItem[] = [];
  selectedCategory: number[] = [];
  selectedTemplateId!: number;
  errorMessage!: string;
  successMessage!: string;
  sendButtonEnable!: boolean;
  partnerEmailTemplateList!: PartnerEmailTemplate[];
  scrollableCols = new Array<any>();
  globalFilterCols = new Array<any>();
  loadingIcon = 'fa-circle-o-notch';
  pageLinksPerPage!: number;
  dataViewRecsPerPage!: number;
  tblPageNumber!: number;
  totalRecords!: number;
  display!: boolean;
  loadEditComponent = false;
  editNav = false;
  showFullscreen = false;
  canShowPreviewModel!: boolean;
  loading = false;
  taskOwnerDrpdwn!: TaskOwner[];
  ftaskOwnerDrpdwn: SelectItem[] = [];
  isDialogOpen!: boolean;
  isEditDialogOpen!: boolean;
  prevTemplateName!: string;
  prevTemplateDesc!: string;
  formEditTemplateDetails!: FormGroup;
  editTemplateDetails!: PartnerBulkEmailTemplateDetails;
  updateErrorMessage!: string;
  updateSuccessMessage!: string;
  @ViewChild('dt', { static: false }) dt!: Table;
  @ViewChildren('tak') components!: QueryList<MultiSelect>;
  @ViewChild('editNavChild', { static: false }) editNavChild!: EditComponent;
  engagementPreviewInput!: EngagementPreviewInput;
  sortableColumnForUploadedDate!: string;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private osm: OsmosisService,
    public localStorage: LocalStorageService
  ) {}
  ngOnInit(): void {
    this.isDialogOpen = false;
    this.isEditDialogOpen = false;
    this.GetPartnerEmailTemplate();
    this.LoadGrid();

    this.formEditTemplateDetails = this.formBuilder.group({
      templateName: [''],
      templateDesc: ['']
    });

    this.refreshData.subscribe(() => {
      this.reset();
    });
  }

  ShowDialog() {
    this.isDialogOpen = true;
  }

  CloseDialog() {
    this.isDialogOpen = false;
  }

  ShowEditDialog() {
    this.isEditDialogOpen = true;
  }

  CloseEditDialog() {
    this.isEditDialogOpen = false;
  }

  GetPartnerEmailTemplate() {
    this.osm.GetPartnerEmailTemplate().subscribe(serviceOutput => {
      this.partnerEmailTemplateList = serviceOutput;
    });
  }

  getEmailTemplate() {
    this.loading = true;
    this.osm
      .getEmailTemplate(this.selectedTemplateId)
      .subscribe(serviceOutput => {
        this.loading = false;
        this.htmlTemplate = serviceOutput.bodyHtml;
        this.subjectTemplate = serviceOutput.subject;
        this.emailAttachments = serviceOutput.emailAttachments;
        this.ShowDialog();
      });
  }

  getRecipientCategoryList() {
    this.osm.GetRecipientCategory().subscribe(serviceOutput => {
      this.recipientCategory = [];
      for (const item of serviceOutput) {
        const recipientCategory: SelectItem = {
          label: item.recipientCategoryName,
          value: item.recipientCategoryId
        };
        this.recipientCategory.push(recipientCategory);
      }
    });
  }

  LoadGrid() {
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;
    this.dataViewRecsPerPage = AppConstants.dataListRecsPerPage;
    this.display = false;
    this.loadEditComponent = false;
    this.editNav = false;
    this.showFullscreen = this.localStorage.getFullscreenMode();

    this.scrollableCols = [
      { field: 'templateName', header: 'Name' },
      { field: 'createdOn', header: 'Date' },
      { field: 'templateDescription', header: 'Description' }
    ];

    this.globalFilterCols = [
      'templateName',
      'createdOn',
      'templateDescription'
    ];
  }

  pageChange(e) {
    this.tblPageNumber = e.first;
  }

  get currentPageInfo(): string {
    if (
      this.partnerEmailTemplateList != null &&
      this.totalRecords == undefined
    ) {
      this.totalRecords = this.partnerEmailTemplateList.length;
    }
    if (this.totalRecords === 0) {
      return 'No Record Found';
    } else if (
      this.tblPageNumber + this.dataViewRecsPerPage >
      this.totalRecords
    ) {
      return (
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records'
      );
    } else if (
      this.tblPageNumber + this.dataViewRecsPerPage <=
      this.totalRecords
    ) {
      return (
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        (this.tblPageNumber + this.dataViewRecsPerPage) +
        ' of ' +
        this.totalRecords +
        ' Records'
      );
    } else if (
      this.totalRecords > 0 &&
      this.totalRecords > this.dataViewRecsPerPage
    ) {
      return (
        'Showing 1 - ' +
        1 * this.dataViewRecsPerPage +
        ' of ' +
        this.totalRecords +
        ' Records'
      );
    } else if (
      this.totalRecords > 0 &&
      this.totalRecords <= this.dataViewRecsPerPage
    ) {
      return (
        'Showing 1 - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records'
      );
    }
    return '';
  }

  applyFilter(event) {
    this.totalRecords = event.filteredValue.length;
    this.pageChange({ first: 0 });
  }

  onShowFullScreenChanged(showFullscreenValue: boolean) {
    this.showFullscreen = showFullscreenValue;
    this.localStorage.setFullscreenMode(this.showFullscreen);
  }

  OpenEmailTemplate(templateId) {
    this.errorMessage = '';
    this.successMessage = '';
    this.selectedCategory = [];
    this.selectedTemplateId = templateId;
    this.sendButtonEnable = false;
    this.getRecipientCategoryList();
    this.getEmailTemplate();
  }

  EditTemplate(templateId) {
    this.GetEmailTemplateDetails(templateId);
  }

  GetEmailTemplateDetails(templateId) {
    this.selectedTemplateId = templateId;
    this.loading = true;
    this.updateSuccessMessage = '';
    this.updateErrorMessage = '';
    this.osm.GetEmailTemplateDetails(templateId).subscribe(result => {
      this.loading = false;
      this.prevTemplateName = result.templateName;
      this.prevTemplateDesc = result.templateDescription;

      this.formEditTemplateDetails.patchValue({
        templateName: result.templateName,
        templateDesc: result.templateDescription
      });

      this.ShowEditDialog();
    });
  }

  onRecipientCategory() {
    if (this.selectedCategory.length > 0) {
      this.sendButtonEnable = true;
      this.errorMessage = '';
      this.successMessage = '';
    } else {
      this.sendButtonEnable = false;
    }
  }

  cancel() {
    this.CloseDialog();
  }

  SendEmail() {
    if (confirm('Are you sure you want to send this email?') == false) {
      return;
    }
    this.errorMessage = '';
    this.successMessage = '';
    if (this.selectedCategory == null || this.selectedCategory.length == 0) {
      this.errorMessage = 'Please select the category.';
      return;
    }

    const SendEmailTemplate: EmailBroadCastInput = {
      recipientCategoryIds: [],
      templateId: this.selectedTemplateId
    };

    for (const item of this.selectedCategory) {
      SendEmailTemplate.recipientCategoryIds.push(item);
    }

    this.sendButtonEnable = false;
    this.loading = true;

    this.osm.sendEmailTemplate(SendEmailTemplate).subscribe(
      () => {
        this.successMessage = 'Email successfully sent.';
        this.loading = false;
      },
      () => {
        this.errorMessage = 'Unable to send the email.';
        this.loading = false;
      }
    );
  }

  onSubmitTemplateInfo() {
    if (
      this.formEditTemplateDetails.controls['templateName'].value != '' &&
      this.formEditTemplateDetails.controls['templateDesc'].value != ''
    ) {
      this.editTemplateDetails = {
        partnerEmailTemplateID: this.selectedTemplateId,
        templateName:
          this.formEditTemplateDetails.controls['templateName'].value,
        templateDescription:
          this.formEditTemplateDetails.controls['templateDesc'].value
      } as PartnerBulkEmailTemplateDetails;

      this.osm.UpdateEmailTemplateDetail(this.editTemplateDetails).subscribe(
        () => {
          this.updateSuccessMessage = 'Template Details Updated Successfully.';
          this.CloseEditDialog();
          this.GetPartnerEmailTemplate();
        },
        () => {
          this.updateErrorMessage =
            'Error occured while updating Template Details.';
        }
      );
    } else {
      if (
        this.formEditTemplateDetails.controls['templateName'].value == '' &&
        this.formEditTemplateDetails.controls['templateDesc'].value == ''
      ) {
        this.updateErrorMessage = 'Name and Description field cannot be blank.';
      } else if (
        this.formEditTemplateDetails.controls['templateName'].value == ''
      ) {
        this.updateErrorMessage = 'Name field cannot be blank.';
      } else if (
        this.formEditTemplateDetails.controls['templateDesc'].value == ''
      ) {
        this.updateErrorMessage = 'Description field cannot be blank.';
      }
    }
  }

  onSave() {
    const isClose = confirm('Do you want to save your changes?');
    if (isClose) {
      this.onSubmitTemplateInfo();
    }
  }

  onCancel() {
    if (
      this.prevTemplateName !=
        this.formEditTemplateDetails.controls['templateName'].value ||
      this.prevTemplateDesc !=
        this.formEditTemplateDetails.controls['templateDesc'].value
    ) {
      const isClose = confirm('Do you want to save your changes?');
      if (isClose) {
        this.onSubmitTemplateInfo();
      } else {
        this.CloseEditDialog();
      }
    } else {
      this.CloseEditDialog();
    }
  }

  reset() {
    this.isDialogOpen = false;
    this.isEditDialogOpen = false;
    this.GetPartnerEmailTemplate();
    this.LoadGrid();

    this.formEditTemplateDetails = this.formBuilder.group({
      templateName: [''],
      templateDesc: ['']
    });
  }
}
